export const FETCH_PLANTS_REQUEST = 'FETCH_PLANTS_REQUEST';
export const FETCH_PLANTS_SUCCESS = 'FETCH_PLANTS_SUCCESS';
export const FETCH_PLANTS_FAILURE = 'FETCH_PLANTS_FAILURE';

export const FETCH_ABSENCES_REQUEST = 'FETCH_ABSENCES_REQUEST';
export const FETCH_ABSENCES_SUCCESS = 'FETCH_ABSENCES_SUCCESS';
export const FETCH_ABSENCES_FAILURE = 'FETCH_ABSENCES_FAILURE';

export const FETCH_ABSENCES_NEXT_REQUEST = 'FETCH_ABSENCES_NEXT_REQUEST';
export const FETCH_ABSENCES_NEXT_SUCCESS = 'FETCH_ABSENCES_NEXT_SUCCESS';
export const FETCH_ABSENCES_NEXT_FAILURE = 'FETCH_ABSENCES_NEXT_FAILURE';

export const FETCH_ABSENCE_REQUEST = 'FETCH_ABSENCE_REQUEST';
export const FETCH_ABSENCE_SUCCESS = 'FETCH_ABSENCE_SUCCESS';
export const FETCH_ABSENCE_FAILURE = 'FETCH_ABSENCE_FAILURE';

export const ADD_ABSENCE_REQUEST = 'ADD_ABSENCE_REQUEST';
export const ADD_ABSENCE_SUCCESS = 'ADD_ABSENCE_SUCCESS';
export const ADD_ABSENCE_FAILURE = 'ADD_ABSENCE_FAILURE';

export const UPDATE_ABSENCE_REQUEST = 'UPDATE_ABSENCE_REQUEST';
export const UPDATE_ABSENCE_SUCCESS = 'UPDATE_ABSENCE_SUCCESS';
export const UPDATE_ABSENCE_FAILURE = 'UPDATE_ABSENCE_FAILURE';

export const UPDATE_ABSENCE_ID = 'UPDATE_ABSENCE_ID';
export const UPDATE_PROGRESS_INDICATOR = 'UPDATE_PROGRESS_INDICATOR';

export const DOWNLOAD_CSV = 'DOWNLOAD_CSV';
export const DOWNLOAD_CSV_SUCCESS = 'DOWNLOAD_CSV_SUCCESS';
export const DOWNLOAD_CSV_FAILURE = 'DOWNLOAD_CSV_FAILURE';

export const UPLOAD_CSV = 'UPLOAD_CSV';
export const UPLOAD_CSV_SUCCESS = 'UPLOAD_CSV_SUCCESS';
export const UPLOAD_CSV_FAILURE = 'UPLOAD_CSV_FAILURE';

export const DELETE_ABSENCE_REQUEST = 'DELETE_ABSENCE_REQUEST';
export const DELETE_ABSENCE_SUCCESS = 'DELETE_ABSENCE_SUCCESS';
export const DELETE_ABSENCE_FAILURE = 'DELETE_ABSENCE_FAILURE';
